import React, { Component, Fragment } from "react";
import Global from "../../../../Global";
import "./PlanSuggestionQuestionSingleSelect.css";
import AnimateHeight from "react-animate-height";

class PlanSuggestionQuestionSingleSelect extends Component {
  constructor(props) {
    super(props);

    const { answers } = this.props;

    this.state = {
      activeIndex: null,
      height: answers == null || Object.keys(answers).length === 0 ? 0 : "100%",
      isExpanded: answers == null || Object.keys(answers).length,
    };

    this.onQuestionNext = this.props.onQuestionNext.bind(this);
    this.onQuestionBack = this.props.onQuestionBack.bind(this);
  }

  handleOptionClick(activeIndex) {
    this.setState({ activeIndex });
  }

  componentDidMount() {
    const { height } = this.state;
    if (height !== 0) return;
    this.setState({ height: "100%" }, () => {
      setTimeout(() => {
        this.setState({ isExpanded: true });
      }, 800);
    });
  }

  render() {
    const { data, step } = this.props;
    const {
      headerTc,
      headerEn,
      questionTc,
      questionEn,
      options,
      trackingIdBack,
      trackingIdNext,
    } = data;

    const { activeIndex, height, isExpanded } = this.state;

    const lang = window.THREE_REACT_APP_GLOBAL.language;
    const header = lang === "tc" ? headerTc : headerEn;
    const question = lang === "tc" ? questionTc : questionEn;
    const labelBack = lang === "tc" ? "上一步" : "Back";
    const labelNext = lang === "tc" ? "下一步" : "Next";

    return (
      <div className="card-question-single-select">
        <div className="header">{header}</div>

        <AnimateHeight
          duration={1000}
          height={height}
          style={{ display: "grid", width: "100%" }}
        >
          <div className="body">
            {height === "100%" && isExpanded ? (
              <Fragment>
                <div className="question">{question}</div>

                <div className="container-options">
                  {options.map((option, index) => {
                    const { labelTc, labelEn, trackingId } = option;
                    const label = lang === "tc" ? labelTc : labelEn;

                    return (
                      <button
                        key={`question-${step}-option-${index + 1}`}
                        className={
                          "btn-outline-transparent " +
                          (activeIndex === index ? "active" : "")
                        }
                        type="button"
                        onClick={() => {
                          this.handleOptionClick(index);
                          window.trackCustomLink(
                            `Online Acq. Select Plan Section | ${trackingId}`
                          );
                        }}
                      >
                        {label}
                      </button>
                    );
                  })}
                </div>

                <div class="container-button-group">
                  <button
                    className="btn-outline-transparent"
                    onClick={() => {
                      window.trackCustomLink(
                        `Online Acq. Select Plan Section | ${trackingIdBack}`
                      );
                      this.onQuestionBack();
                    }}
                  >
                    {labelBack}
                  </button>

                  <button
                    className="btn-outline-transparent"
                    onClick={() => {
                      if (activeIndex == null) return;
                      window.trackCustomLink(
                        `Online Acq. Select Plan Section | ${trackingIdNext}`
                      );
                      this.onQuestionNext(activeIndex);
                    }}
                  >
                    {labelNext}
                  </button>
                </div>
              </Fragment>
            ) : null}
          </div>
        </AnimateHeight>
      </div>
    );
  }
}

export default PlanSuggestionQuestionSingleSelect;
